/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderAlert
 */
export interface OrderAlert {
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAlert
     */
    orgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAlert
     */
    centerName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OrderAlert
     */
    orderDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAlert
     */
    orgSupplierId: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAlert
     */
    supplierName: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAlert
     */
    orderLimitTime: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    todayOrderCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    stockAlertCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    expectedRankAlertCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    minShipDateAlertCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    endSaleAlertCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    missingItemAlertCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    stockDaysAlertCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    masterNotFoundAlertCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderAlert
     */
    otherItemAlertCount: number | null;
}

/**
 * Check if a given object implements the OrderAlert interface.
 */
export function instanceOfOrderAlert(value: object): value is OrderAlert {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('centerName' in value) || value['centerName'] === undefined) return false;
    if (!('orderDate' in value) || value['orderDate'] === undefined) return false;
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('supplierName' in value) || value['supplierName'] === undefined) return false;
    if (!('orderLimitTime' in value) || value['orderLimitTime'] === undefined) return false;
    if (!('todayOrderCount' in value) || value['todayOrderCount'] === undefined) return false;
    if (!('stockAlertCount' in value) || value['stockAlertCount'] === undefined) return false;
    if (!('expectedRankAlertCount' in value) || value['expectedRankAlertCount'] === undefined) return false;
    if (!('minShipDateAlertCount' in value) || value['minShipDateAlertCount'] === undefined) return false;
    if (!('endSaleAlertCount' in value) || value['endSaleAlertCount'] === undefined) return false;
    if (!('missingItemAlertCount' in value) || value['missingItemAlertCount'] === undefined) return false;
    if (!('stockDaysAlertCount' in value) || value['stockDaysAlertCount'] === undefined) return false;
    if (!('masterNotFoundAlertCount' in value) || value['masterNotFoundAlertCount'] === undefined) return false;
    if (!('otherItemAlertCount' in value) || value['otherItemAlertCount'] === undefined) return false;
    return true;
}

export function OrderAlertFromJSON(json: any): OrderAlert {
    return OrderAlertFromJSONTyped(json, false);
}

export function OrderAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'orgCenterId': json['org_center_id'],
        'centerName': json['center_name'],
        'orderDate': (json['order_date'] == null ? null : new Date(json['order_date'])),
        'orgSupplierId': json['org_supplier_id'],
        'supplierName': json['supplier_name'],
        'orderLimitTime': json['order_limit_time'],
        'todayOrderCount': json['today_order_count'],
        'stockAlertCount': json['stock_alert_count'],
        'expectedRankAlertCount': json['expected_rank_alert_count'],
        'minShipDateAlertCount': json['min_ship_date_alert_count'],
        'endSaleAlertCount': json['end_sale_alert_count'],
        'missingItemAlertCount': json['missing_item_alert_count'],
        'stockDaysAlertCount': json['stock_days_alert_count'],
        'masterNotFoundAlertCount': json['master_not_found_alert_count'],
        'otherItemAlertCount': json['other_item_alert_count'],
    };
}

export function OrderAlertToJSON(json: any): OrderAlert {
    return OrderAlertToJSONTyped(json, false);
}

export function OrderAlertToJSONTyped(value?: OrderAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'org_center_id': value['orgCenterId'],
        'center_name': value['centerName'],
        'order_date': value['orderDate'] == null ? value['orderDate'] : value['orderDate'].toISOString(),
        'org_supplier_id': value['orgSupplierId'],
        'supplier_name': value['supplierName'],
        'order_limit_time': value['orderLimitTime'],
        'today_order_count': value['todayOrderCount'],
        'stock_alert_count': value['stockAlertCount'],
        'expected_rank_alert_count': value['expectedRankAlertCount'],
        'min_ship_date_alert_count': value['minShipDateAlertCount'],
        'end_sale_alert_count': value['endSaleAlertCount'],
        'missing_item_alert_count': value['missingItemAlertCount'],
        'stock_days_alert_count': value['stockDaysAlertCount'],
        'master_not_found_alert_count': value['masterNotFoundAlertCount'],
        'other_item_alert_count': value['otherItemAlertCount'],
    };
}

